import { MODE_RULES } from '../constants/options';
import type { ImageToVideoState } from '../atoms/state';

export const canGenerate = (state: ImageToVideoState) => {
  const { style } = state;
  const rules = MODE_RULES[style.mode];

  if (!rules) {
    return false;
  }

  return Boolean(
    (style.estateId || style.projectId) &&
      style.images.length >= rules.minImages &&
      style.images.length <= rules.maxImages &&
      style.durationSec >= rules.minDuration &&
      style.durationSec <= rules.maxDuration
  );
};
